import Gpay from "../Pages/Gpay"
import DownloadedProfilePage from "../Pages/HomePages/DownloadedProfilePage"
import HomePage from "../Pages/HomePages/HomePage"
import ManageImage from "../Pages/HomePages/ManageImage"
import MobileHistory from "../Pages/HomePages/MobileHistory"
import NotInterestedPage from "../Pages/HomePages/NotInterestedPage"
import EditUser from "../Pages/HomePages/User/EditUser"
import FamilyHistory from "../Pages/HomePages/User/FamilyHistory"
import ViewUser from "../Pages/HomePages/User/ViewUser"
import WishListPage from "../Pages/HomePages/WishListPage"
import AboutPage from "../Pages/LandingPages/AboutPage"
import ContactPage from "../Pages/LandingPages/ContactPage"
import ForgotPassword from "../Pages/Auth/ForgotPassword"
import LandingHomePage from '../Pages/LandingPages/HomePage'
import PricingPlan from "../Pages/LandingPages/PricingPlan"
import SuccessStories from "../Pages/LandingPages/SuccessStories"

export const homeRoutes = [
    {
        link: '/home',
        component: HomePage
    },
    {
        link: '/fullProfile/:id',
        component: ViewUser
    },
    {
        link: '/viewProfile/:id',
        component: ViewUser
    },
    {
        link: '/subscription',
        component: () => <PricingPlan />
    },
    {
        link: '/wishList',
        component: WishListPage
    },
    {
        link: '/notInterested',
        component: NotInterestedPage
    },
    {
        link: '/profile/edit/:id',
        component: EditUser
    },
    {
        link: '/profile/manageImages',
        component: ManageImage
    },
    {
        link: '/downloadedProfiles',
        component: DownloadedProfilePage
    },
    {
        link: '/payment',
        component: Gpay
    },
    {
        link:'/profileHistory',
        component:MobileHistory
    },
    {
        link:"/user/familyHistory/:id",
        component:FamilyHistory
    }
]

export const CombinedRoutes = [...homeRoutes]


export const landingHomeRoutes = [
    {
        link: "/",
        component: LandingHomePage
    },
    {
        link: "/aboutUs",
        component: AboutPage
    },
    {
        link: "/contactUs",
        component: ContactPage
    },
    {
        link:'/successStories',
        component:SuccessStories
    },
    {
        link: "/pricing",
        component: PricingPlan
    },
    {
        link:'/forgotPassord',
        component:ForgotPassword
}
]

export const CombinedLandingRoutes = [...landingHomeRoutes]
